import React from "react";
import StyledSwitch from "./StyledSwitch";
import {
    BulkSectionDivider, BulkSectionHeader, BulkSectionTitle, BulkSectionDescription,
    DefaultPermissionToggle, DefaultPermissionToggleHint
} from "./DefaultPermissionAssignmentStyles";

type Props = {
    userTypeLabel: string;
    enabled: boolean;
    disabled: boolean;
    onChange: (enabled: boolean) => void;
};

export default function DefaultPermissionAssignment({ userTypeLabel, enabled, disabled, onChange }: Props) {
    return <>
        <BulkSectionDivider />
        <BulkSectionHeader>
            <BulkSectionTitle>Default Permission Assignment</BulkSectionTitle>
            <BulkSectionDescription>
                Automatically assign these selected roles and permissions to all future {userTypeLabel}.
            </BulkSectionDescription>
            <DefaultPermissionToggle>
                <span>Automatically assign to all future {userTypeLabel.toLowerCase()}</span>
                <DefaultPermissionToggleHint>Turn off/on</DefaultPermissionToggleHint>
                <StyledSwitch
                    switchMargin={8}
                    checkedTrackColor="#1A61FF"
                    thumbBorderColor="#bdbdbd"
                    thumbBackgroundColor="#FFFF"
                    trackBackgroundColor="#00000029"
                    trackHeight={20}
                    trackRadius={23 / 2}
                    checked={enabled}
                    disabled={disabled}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
                    inputProps={{ "aria-label": `Automatically assign to all future ${userTypeLabel.toLowerCase()}` }}
                />
            </DefaultPermissionToggle>
        </BulkSectionHeader>
    </>;
}
